/**
 * @generated SignedSource<<6f05dd725a8cfa22bfcd523796b66635>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BrainSearchMessageType = "assistant" | "user" | "%future added value";
export type BrainSearchPageContent__createMessageMutation$variables = {
  id: string;
  sourceRelatedQuestionId?: string | null;
  userText: string;
};
export type BrainSearchPageContent__createMessageMutation$data = {
  readonly createBrainSearchMessage: {
    readonly assistantMessage: {
      readonly id: string;
      readonly messageText: string;
      readonly sources: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          };
        }>;
      } | null;
      readonly type: BrainSearchMessageType;
    };
    readonly userMessage: {
      readonly brainSearchId: string;
      readonly id: string;
      readonly messageText: string;
      readonly type: BrainSearchMessageType;
    };
  };
};
export type BrainSearchPageContent__createMessageMutation = {
  response: BrainSearchPageContent__createMessageMutation$data;
  variables: BrainSearchPageContent__createMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceRelatedQuestionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userText"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "messageText",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brainSearchId",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "sourceRelatedQuestionId",
        "variableName": "sourceRelatedQuestionId"
      },
      {
        "kind": "Variable",
        "name": "userText",
        "variableName": "userText"
      }
    ],
    "concreteType": "CreateBrainSearchMessageResponse",
    "kind": "LinkedField",
    "name": "createBrainSearchMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BrainSearchMessage",
        "kind": "LinkedField",
        "name": "userMessage",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "brainSearchId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BrainSearchMessage",
        "kind": "LinkedField",
        "name": "assistantMessage",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrainSearchMessageSourceNodeConnection",
            "kind": "LinkedField",
            "name": "sources",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BrainSearchMessageSourceNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BrainSearchMessageSource",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BrainSearchPageContent__createMessageMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "BrainSearchPageContent__createMessageMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "d1163d5c420b17672ee4d4d9e9167d74",
    "id": null,
    "metadata": {},
    "name": "BrainSearchPageContent__createMessageMutation",
    "operationKind": "mutation",
    "text": "mutation BrainSearchPageContent__createMessageMutation(\n  $id: ID!\n  $userText: String!\n  $sourceRelatedQuestionId: ID\n) {\n  createBrainSearchMessage(brainSearchId: $id, userText: $userText, sourceRelatedQuestionId: $sourceRelatedQuestionId) {\n    userMessage {\n      id\n      messageText\n      type\n      brainSearchId\n    }\n    assistantMessage {\n      id\n      messageText\n      type\n      sources {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a41ade6e484ecc1c7921845a38735b4";

export default node;
